import React, { useState, useCallback } from "react";

// Move styles outside component to prevent recreation
const styles = {
  container: {
    border: "1px solid #ddd",
    borderRadius: "10px",
    marginBottom: "12px",
  },
  header: {
    padding: "12px 16px",
    background: "#f8f8f8",
    cursor: "pointer",
    fontWeight: "600",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
};

const CollapsibleSection = React.memo(
  function CollapsibleSection({
    title,
    children,
    defaultOpen = false,
    triggerClose,
  }) {
    const [open, setOpen] = useState(defaultOpen);
    const [allowOverflow, setAllowOverflow] = useState(defaultOpen);

    // Keep the section clipped while it animates open or closed.
    // Once it is open, let dropdowns such as the date picker draw outside it.
    React.useEffect(() => {
      if (!open) {
        setAllowOverflow(false);
        return undefined;
      }
      const timer = setTimeout(() => setAllowOverflow(true), 350);
      return () => clearTimeout(timer);
    }, [open]);

    const contentStyle = {
      maxHeight: open ? "2000px" : "0px",
      overflow: allowOverflow ? "visible" : "hidden",
      transition: "max-height 0.35s ease",
      padding: open ? "16px" : "0px",
    };
    React.useEffect(() => {
      if (triggerClose) {
        setOpen(false);
      }
    }, [triggerClose]);

    return (
      <div style={styles.container}>
        <div onClick={() => setOpen((prev) => !prev)} style={styles.header}>
          {title}
          <span>{open ? "▲" : "▼"}</span>
        </div>

        <div style={contentStyle}>{children}</div>
      </div>
    );
  },
  // Custom comparison function - only re-render if title changes
  (prevProps, nextProps) => {
    return prevProps === nextProps;
  },
);

export default CollapsibleSection;